import React, { useState, useEffect } from "react";
import { Link } from 'react-router-dom';
import './MenuLateral.css';
import { useAuth } from "../../Context/auth";
import ModalConfiguracoes from "../ModalConfiguracoes/ModalConfiguracoes";
import ModalTutorial from "./ModalTutorial";
import Swal from 'sweetalert2';

function MenuLateral() {
    const { appUserData, signOutUser } = useAuth();
    const [diasRestantes, setDiasRestantes] = useState(null);
    const [showConfigModal, setShowConfigModal] = useState(false);
    const [showTutorialModal, setShowTutorialModal] = useState(false);

    // State to toggle submenus
    const [mobileOpen, setMobileOpen] = useState(false);
    const [openMenus, setOpenMenus] = useState({});

    const toggleMenu = (menuKey) => {
        setOpenMenus(prev => ({
            ...prev,
            [menuKey]: !prev[menuKey]
        }));
    };

    // ... existing logic ...

    // Close mobile menu when navigating
    const handleNavigation = (e, path, permissionKey) => {
        // ... permission check ...
        if (appUserData && appUserData[permissionKey] === false) {
            e.preventDefault();
            // ... swal ...
            return;
        }
        setMobileOpen(false); // Close menu on mobile click
    };

    // Also close on simple links like "Início"
    const handleMobileLinkClick = () => {
        setMobileOpen(false);
    }


    const numeroWhatsapp = "5537999826905";

    // --- NOVA LÓGICA DE MÓDULOS ---
    const modulos = appUserData?.modulos || [];

    const hasModuloEstoque = modulos.includes(2);
    const hasModuloProducao = modulos.includes(3);

    // Ocultar menus se não tiver o módulo correspondente
    // Se não tiver Essencial, teoricamente não veria nada, mas vamos assumir que o login garante algo ou redireciona.
    // Menus Industriais (Insumos, Etapas) aparecem apenas com módulo Produção ou Estoque?
    // Pelo pedido: "Modulo estoque adiciona telas de estoque e movimentações."
    // "Modulo produção adiciona aba ficha tecnica e tela produção."
    // Insumos e Etapas parecem ligados a produção de certa forma, mas Insumos podem ser estoque também.
    // Vamos ligar Insumos e Etapas ao Módulo 3 (Produção) pois "Ficha técnica" depende deles.

    useEffect(() => {
        if (appUserData && (appUserData.tenant_status === 1 || appUserData.tenant_status === 2) && appUserData.data_vencimento) {
            const dataVencimento = new Date(appUserData.data_vencimento);
            const hoje = new Date();
            hoje.setHours(0, 0, 0, 0);
            dataVencimento.setHours(0, 0, 0, 0);
            const diffTime = dataVencimento.getTime() - hoje.getTime();
            const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
            setDiasRestantes(diffDays);
        } else {
            setDiasRestantes(null);
        }
    }, [appUserData]);

    const handleLogout = () => {
        signOutUser();
    };



    const renderExpirationStatus = () => {
        if (!appUserData || diasRestantes === null) return null;
        const { tenant_status, tenant_nome } = appUserData;

        const mensagemContratar = `Assinante: ${tenant_nome || ''}. Estou em periodo de testes e gostaria de contratar o R6 ERP.`;
        const linkWhatsappContratar = `https://wa.me/${numeroWhatsapp}?text=${encodeURIComponent(mensagemContratar)}`;
        const mensagemRenovar = `Assinante: ${tenant_nome || ''}. Olá. Gostaria de renovar minha licença.`;
        const linkWhatsappRenovar = `https://wa.me/${numeroWhatsapp}?text=${encodeURIComponent(mensagemRenovar)}`;

        if (tenant_status === 2) {
            const buttonTrial = (
                <a href={linkWhatsappContratar} target="_blank" rel="noopener noreferrer" className="btn btn-sm btn-success btn-sidebar-action">
                    <i className="fab fa-whatsapp me-2"></i>Contratar
                </a>
            );

            if (diasRestantes <= 0) {
                return (
                    <div className="trial-alert-sidebar alert-danger">
                        <div>Período de teste expirado</div>
                        {buttonTrial}
                    </div>
                );
            }
            return (
                <div className="trial-alert-sidebar alert-warning">
                    <div>Testes: resta(m) <strong>{diasRestantes} dia(s)</strong></div>
                    {buttonTrial}
                </div>
            );
        }

        if (tenant_status === 1) {
            if (diasRestantes > 7) return null;
            const buttonRenew = (
                <a href={linkWhatsappRenovar} target="_blank" rel="noopener noreferrer" className="btn btn-sm btn-success btn-sidebar-action">
                    <i className="fab fa-whatsapp me-2"></i>Renovar
                </a>
            );
            if (diasRestantes <= 0) {
                return (
                    <div className="trial-alert-sidebar alert-danger">
                        <div>Licença expirada</div>
                        {buttonRenew}
                    </div>
                );
            }
            return (
                <div className="trial-alert-sidebar alert-warning">
                    <div>Vence em <strong>{diasRestantes} dia(s)</strong></div>
                    {buttonRenew}
                </div>
            );
        }
        return null;
    };

    return (
        <>
            {/* Overlay for Mobile */}
            <div
                className={`sidebar-overlay ${mobileOpen ? 'show' : ''}`}
                onClick={() => setMobileOpen(false)}
            ></div>

            {/* --- SIDEBAR --- */}
            <div className={`sidebar-wrapper ${mobileOpen ? 'mobile-open' : ''}`}>
                <div className="sidebar-header">
                    <Link to="/app/home" className="d-flex justify-content-center align-items-center w-100" onClick={handleMobileLinkClick}>
                        <img
                            src="/imagens/logo_r6_cloud.png"
                            alt="R6 ERP"
                            className="sidebar-logo"
                        />
                    </Link>
                    <button className="btn-close-sidebar d-md-none ms-2" onClick={() => setMobileOpen(false)}>
                        <i className="fas fa-times"></i>
                    </button>
                </div>

                <div className="sidebar-nav">

                    <Link to="/app/home" className="sidebar-item" onClick={handleMobileLinkClick}>
                        <i className="fa-solid fa-house"></i> <span className="sidebar-label">Início</span>
                    </Link>

                    {/* Cadastros Básicos */}
                    <div>
                        <button
                            className={`sidebar-item sidebar-dropdown-toggle ${openMenus['cadastros'] ? 'active' : ''}`}
                            onClick={() => toggleMenu('cadastros')}
                            aria-expanded={openMenus['cadastros']}
                        >
                            <i className="fa-solid fa-folder-open"></i> <span className="sidebar-label">Cadastros</span>
                        </button>
                        {openMenus['cadastros'] && (
                            <div className="sidebar-submenu">
                                <Link to="/app/marcas" className="sidebar-submenu-item" onClick={(e) => handleNavigation(e, '/app/marcas', 'ler_marcas')}>Marcas</Link>
                                <Link to="/app/unidadesmedida" className="sidebar-submenu-item" onClick={(e) => handleNavigation(e, '/app/unidadesmedida', 'ler_unidades_medida')}>Unid. Medida</Link>
                                <Link to="/app/grades" className="sidebar-submenu-item" onClick={(e) => handleNavigation(e, '/app/grades', 'ler_grades')}>Grades</Link>
                                {hasModuloProducao && (
                                    <Link to="/app/etapas-producao" className="sidebar-submenu-item" onClick={(e) => handleNavigation(e, '/app/etapas-producao', 'ler_etapas_producao')}>Etapas Prod.</Link>
                                )}
                            </div>
                        )}
                    </div>

                    <Link to="/app/empresas" className="sidebar-item" onClick={(e) => handleNavigation(e, '/app/empresas', 'ler_empresas')}>
                        <i className="fa-solid fa-building"></i> <span className="sidebar-label">Empresas</span>
                    </Link>

                    {hasModuloProducao && (
                        <Link to="/app/insumos" className="sidebar-item" onClick={(e) => handleNavigation(e, '/app/insumos', 'ler_insumos')}>
                            <i className="fa-solid fa-cubes"></i> <span className="sidebar-label">Insumos</span>
                        </Link>
                    )}

                    <Link to="/app/produtos" className="sidebar-item" onClick={(e) => handleNavigation(e, '/app/produtos', 'ler_produtos')}>
                        <i className="fa-solid fa-box-open"></i> <span className="sidebar-label">Produtos</span>
                    </Link>

                    {hasModuloEstoque && (
                        <div>
                            <button
                                className={`sidebar-item sidebar-dropdown-toggle ${openMenus['estoque'] ? 'active' : ''}`}
                                onClick={() => toggleMenu('estoque')}
                            >
                                <i className="fa-solid fa-warehouse"></i> <span className="sidebar-label">Estoque</span>
                            </button>
                            {openMenus['estoque'] && (
                                <div className="sidebar-submenu">
                                    <Link to="/app/estoque" className="sidebar-submenu-item">Estoque</Link>
                                    <Link to="/app/movimentacoes" className="sidebar-submenu-item" onClick={(e) => handleNavigation(e, '/app/movimentacoes', 'ler_movimentacoes')}>Movimentações</Link>
                                </div>
                            )}
                        </div>
                    )}

                    {/* Vendas */}
                    <div>
                        <button
                            className={`sidebar-item sidebar-dropdown-toggle ${openMenus['vendas'] ? 'active' : ''}`}
                            onClick={() => toggleMenu('vendas')}
                        >
                            <i className="fa-solid fa-cart-shopping"></i> <span className="sidebar-label">Vendas</span>
                        </button>
                        {openMenus['vendas'] && (
                            <div className="sidebar-submenu">
                                <Link to="/app/pedidos" className="sidebar-submenu-item" onClick={(e) => handleNavigation(e, '/app/pedidos', 'ler_pedidos')}>Pedidos</Link>
                                <Link to="/app/vendas/dashboard" className="sidebar-submenu-item">Dashboard</Link>
                            </div>
                        )}
                    </div>

                    {hasModuloProducao && (
                        <Link to="/app/producao" className="sidebar-item" onClick={(e) => handleNavigation(e, '/app/producao', 'ler_producao')}>
                            <i className="fa-solid fa-industry"></i> <span className="sidebar-label">Produção</span>
                        </Link>
                    )}

                    {/* Financeiro */}
                    <div>
                        <button
                            className={`sidebar-item sidebar-dropdown-toggle ${openMenus['financeiro'] ? 'active' : ''}`}
                            onClick={() => toggleMenu('financeiro')}
                        >
                            <i className="fa-solid fa-coins"></i> <span className="sidebar-label">Financeiro</span>
                        </button>
                        {openMenus['financeiro'] && (
                            <div className="sidebar-submenu">
                                <Link to="/app/financeiroareceber" className="sidebar-submenu-item" onClick={(e) => handleNavigation(e, '/app/financeiroareceber', 'ler_financeiro_a_receber')}>A Receber</Link>
                                <Link to="/app/financeiroapagar" className="sidebar-submenu-item" onClick={(e) => handleNavigation(e, '/app/financeiroapagar', 'ler_financeiro_a_pagar')}>A Pagar</Link>
                                <Link to="/app/financeiro/dashboard" className="sidebar-submenu-item">Dashboard</Link>
                            </div>
                        )}
                    </div>



                    {appUserData?.is_admin_r6 === true && (
                        <div>
                            <button
                                className={`sidebar-item sidebar-dropdown-toggle ${openMenus['gerencial'] ? 'active' : ''}`}
                                onClick={() => toggleMenu('gerencial')}
                            >
                                <i className="fa-solid fa-chart-line"></i> <span className="sidebar-label">Gerencial</span>
                            </button>
                            {openMenus['gerencial'] && (
                                <div className="sidebar-submenu">
                                    <Link to="/app/gerencial/clientes" className="sidebar-submenu-item">Clientes</Link>
                                    <Link to="/app/gerencial/logs" className="sidebar-submenu-item">Logs</Link>
                                    <Link to="/app/gerencial/modulos" className="sidebar-submenu-item">Módulos</Link>
                                    <Link to="/app/gerencial/dashboard" className="sidebar-submenu-item">Dashboard</Link>
                                </div>
                            )}
                        </div>
                    )}

                    {/* CONFIGURAÇÕES - Moved below Gerencial */}
                    <button
                        className="sidebar-item"
                        onClick={() => {
                            if (appUserData && appUserData['ler_configuracoes'] === false) {
                                Swal.fire({
                                    icon: 'error',
                                    title: 'Acesso Negado',
                                    text: 'Este usuário não possui permissão de acesso a este menu.',
                                    confirmButtonColor: '#2185c6'
                                });
                                return;
                            }
                            setShowConfigModal(true);
                            setMobileOpen(false);
                        }}
                    >
                        <i className="fa-solid fa-gear"></i> <span className="sidebar-label">Configurações</span>
                    </button>

                    {/* Área do Cliente */}
                    <div className="mt-auto">
                        <button
                            className={`sidebar-item sidebar-dropdown-toggle ${openMenus['cliente'] ? 'active' : ''}`}
                            onClick={() => toggleMenu('cliente')}
                        >
                            <i className="fa-solid fa-headset"></i> <span className="sidebar-label">Área do Cliente</span>
                        </button>
                        {openMenus['cliente'] && (
                            <div className="sidebar-submenu">
                                <a
                                    href={`https://wa.me/5537999826905?text=${encodeURIComponent(`Assinante: ${appUserData?.tenant_nome || 'N/A'} - Falar com o suporte`)}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="sidebar-submenu-item"
                                >
                                    Falar com o suporte
                                </a>
                                <button
                                    className="sidebar-submenu-item btn-link-custom text-start"
                                    onClick={() => {
                                        setShowTutorialModal(true);
                                        setMobileOpen(false);
                                    }}
                                >
                                    Tutorial Completo
                                </button>
                            </div>
                        )}
                    </div>





                </div>
            </div>

            {/* --- TOP BAR --- */}
            <div className="topbar-wrapper">
                {/* Hamburger Button (Left) */}
                <button className="hamburger-btn" onClick={() => setMobileOpen(!mobileOpen)}>
                    <i className="fas fa-bars"></i>
                </button>

                <div className="d-flex align-items-center ms-auto">
                    {/* Expiration Status */}
                    <div className="me-3 d-none d-md-block">
                        {renderExpirationStatus()}
                    </div>

                    {/* Minha Conta Dropdown */}
                    <div className="dropdown">
                        <button
                            className="btn btn-link text-decoration-none dropdown-toggle d-flex align-items-center text-white"
                            type="button"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                        >
                            <div className="avatar-circle me-2">
                                <i className="fa-solid fa-user"></i>
                            </div>
                            <span className="fw-bold d-none d-md-block">{appUserData?.user_nome?.split(' ')[0] || 'Minha Conta'}</span>
                        </button>
                        <ul className="dropdown-menu dropdown-menu-end shadow-sm border-0">
                            <li>
                                <Link to="/app/minhaconta" className="dropdown-item" onClick={(e) => handleNavigation(e, '/app/minhaconta', 'ler_minhaconta')}>
                                    <i className="fas fa-id-card me-2 text-muted"></i> Meus Dados
                                </Link>
                            </li>
                            <li>
                                <Link to="/app/usuarios" className="dropdown-item" onClick={(e) => handleNavigation(e, '/app/usuarios', 'ler_usuarios')}>
                                    <i className="fas fa-users me-2 text-muted"></i> Usuários
                                </Link>
                            </li>
                            <li><hr className="dropdown-divider" /></li>
                            <li>
                                <button onClick={handleLogout} className="dropdown-item text-danger">
                                    <i className="fas fa-sign-out-alt me-2"></i> Sair
                                </button>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>

            <ModalConfiguracoes
                isVisible={showConfigModal}
                onClose={() => setShowConfigModal(false)}
            />
            <ModalTutorial
                isVisible={showTutorialModal}
                onClose={() => setShowTutorialModal(false)}
                videoId="VRLhPbuD24A"
            />
        </>
    );
}

export { MenuLateral };
export default MenuLateral;
